import Vue from 'vue';
import VueRouter from 'vue-router';
import EditorView from '@/views/EditorView.vue';
import FullScreenPreview from '@/views/FullScreenPreview.vue';
import LoginView from '@/views/LoginView.vue';
// 安装Vue Router插件
Vue.use(VueRouter);

// 创建路由实例并定义路由规则
const routes = [
    { path: '/', component: LoginView },
    { path: '/Editor', component: EditorView },
    { path: '/preview', component : FullScreenPreview},
    { path: '/Login', component : LoginView},    
];
const router = new VueRouter({
    routes
});

export default router;